module.exports = __webpack_public_path__ + "static/media/3 09 Tulleord Vor er riktig.37a0d611.mp3";